<div wnlGroup #wnlGroup="wnlGroup">
  <div class="wnl-header">
    <p>
      WNL: Regular rate, rhythm, SI S2, no edema, extremities warm with capillary refill less than 3
      seconds. Pulses strong. No chest pain or palpations. No cyanosis.
    </p>

    <mat-checkbox [checked]="wnlGroup.allWnl" [indeterminate]="wnlGroup.someWnl"
      (change)="wnlGroup.setAllWnl($event.checked)"
      [ngClass]="{'wnl-checked': wnlGroup.allWnl && !wnlGroup.someWnl, 'wnl-indeterminate': wnlGroup.someWnl}">
      All Within Normal Limits
    </mat-checkbox>
  </div>

  <div [formGroup]="formGroup()" class="form-container">
  <div class="heartTones">
    <h2>Heart Tones</h2>

    <assessment-row title="Pulse Pattern">
      <emr-checkbox [control]="formGroup().controls.pulsePattern" label="Irregular" [wnlControl]="'pulsePattern'"
        [wnlDefault]="false" />
    </assessment-row>
    <assessment-row title="Heart Tones">
      <emr-input type="select" [control]="formGroup().controls.heartTones" [options]="heartTonesOptions"
        [wnlControl]="'heartTones'" [wnlDefault]="'WNL'" />
    </assessment-row>
    <assessment-row title="Rhythm">
      <emr-input type="select" [control]="formGroup().controls.rhythm" [options]="rhythmOptions"
        [wnlControl]="'rhythm'" [wnlDefault]="'NSR'" />
      @if (isOtherRhythm) {
      <emr-input type="text" label="Comments" [control]="formGroup().controls.rhythmOther" />
      }
    </assessment-row>
  </div>

  <div class="edema-container">
    <h2>Edema</h2>
    <div class="edema-checkboxes">
      <emr-checkbox [control]="formGroup().controls.jvd" label="Presence of JVD" [wnlControl]="'jvd'"
        [wnlDefault]="false" />
      <emr-checkbox [control]="formGroup().controls.gnpe" label="Generalized Non-Pitting Edema"
        [wnlControl]="'gnpe'" [wnlDefault]="false" />
    </div>

    <h2>Pitting Edema</h2>
    <div class="pitting-edema">
      <emr-input type="select" label="Right Hand" [control]="formGroup().controls.rightHand"
        [options]="pittingEdemaOptions" [wnlControl]="'rightHand'" [wnlDefault]="'WNL'" [bottomSpace]="true" />
      <emr-input type="select" label="Left Hand" [control]="formGroup().controls.leftHand"
        [options]="pittingEdemaOptions" [wnlControl]="'leftHand'" [wnlDefault]="'WNL'" [bottomSpace]="true" />
      <emr-input type="select" label="Right Foot" [control]="formGroup().controls.rightFoot"
        [options]="pittingEdemaOptions" [wnlControl]="'rightFoot'" [wnlDefault]="'WNL'" [bottomSpace]="true" />
      <emr-input type="select" label="Left Foot" [control]="formGroup().controls.leftFoot"
        [options]="pittingEdemaOptions" [wnlControl]="'leftFoot'" [wnlDefault]="'WNL'" [bottomSpace]="true" />
    </div>
  </div>

  <div class="other">
    <assessment-row title="Generalized Perfusion">
      <emr-input type="select" [control]="formGroup().controls.generalizedPerfusion"
        [options]="generalizedPerfusionOptions" [wnlControl]="'generalizedPerfusion'" [wnlDefault]="'WNL'" />
    </assessment-row>
    <assessment-row title="Cap Refill">
      <emr-checkbox [control]="formGroup().controls.capRefill" label="> 3 seconds" [wnlControl]="'capRefill'"
        [wnlDefault]="false" />
    </assessment-row>

    <h2>Pulses</h2>
    <div class="pulses">
      <emr-input type="select" label="RUE" [control]="formGroup().controls.pulseRue" [options]="pulseOptions"
        [wnlControl]="'rue'" [wnlDefault]="'+2 normal'" [bottomSpace]="true" />
      <emr-input type="select" label="LUE" [control]="formGroup().controls.pulseLue" [options]="pulseOptions"
        [wnlControl]="'lue'" [wnlDefault]="'+2 normal'" [bottomSpace]="true" />
      <emr-input type="select" label="RLE" [control]="formGroup().controls.pulseRle" [options]="pulseOptions"
        [wnlControl]="'rle'" [wnlDefault]="'+2 normal'" [bottomSpace]="true" />
      <emr-input type="select" label="LLE" [control]="formGroup().controls.pulseLle" [options]="pulseOptions"
        [wnlControl]="'lle'" [wnlDefault]="'+2 normal'" [bottomSpace]="true" />
    </div>

    <assessment-row title="Cyanosis Noted">
      <emr-input type="text" [control]="formGroup().controls.cyanosisNoted" [wnlControl]="'cyanosisNoted'"
        [wnlDefault]="''" />
    </assessment-row>

    <assessment-row title="Pace Maker">
      <emr-checkbox [control]="formGroup().controls.pacemaker" label="Yes" [wnlControl]="'pacemaker'"
        [wnlDefault]="false" />
    </assessment-row>
    @if (isPaceMaker) {
    <emr-input type="text" label="Comments" [control]="formGroup().controls.pacemakerComment" />
    }

    <assessment-row title="Other Findings">
      <emr-input type="text" [control]="formGroup().controls.otherFindings" [wnlControl]="'otherFindings'"
        [wnlDefault]="''" />
    </assessment-row>
  </div>
</div>
</div>